export default "__VITE_ASSET__CmWfkeia__"